module.exports = __webpack_public_path__ + "img/cabbage-posterized-small-charlie.b48f10bc.png";